import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import moment from 'moment';
import Modal from 'react-modal';

moment.locale('ja');
window.moment = moment;
Modal.setAppElement('#root');

ReactDOM.render(<App />, document.getElementById('root'));
